import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { makeStyles } from '@mui/styles';

import { constants } from '../../Constants/constants';
import { put, getOne } from "../../helper/baseFetch";
import { getScDisabled } from "../../helper/util";
import { setArea, setAreaValue } from "../../actions/areaAction";
import { DistrictList } from '../District/DistrictList';
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay';
import { TempTextInput } from "../../Component/Input/TempTextInput";
import { TempAutoSelectInput } from "../../Component/Input/TempAutoSelectInput";
import { TempCustomCheckBox } from "../../Component/Custom/TempCustomCheckBox";
import { GlobalDialog } from "../../Component/GlobalDialog";
import AreaValidation from "../../validations/areaValidation";
import { areaValidationConstants } from '../../Constants/validationConstants';

const helperTextStyles = makeStyles(theme => ({
  root: {
    color: "red !important",
  },
}));

export const AreaEdit = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const params = useParams();
  const history = useHistory();
  const [ready, setReady] = useState(false);
  const [clear, setClear] = useState(true);
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: []
  });
  const resource = "Area";
  const savedArea = useSelector(state => state.area.ui.area)
  const [areaInputList, setAreaInputList] = useState(_.cloneDeep(savedArea));
  const helperTextStylesClasses = helperTextStyles();
  const [, setErrorVersion] = useState(AreaValidation.getVersion());

  const tabs = [
    {
      label: { resource: resource, key: "info" },
      tabIndex: constants.AREA_EDIT_TAB.INFO
    },
    {
      label: { resource: resource, key: "districtList" },
      tabIndex: constants.AREA_EDIT_TAB.DISTRICT_LIST
    }
  ]
  const tempAreaEditList = [
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "enName" },
      value: savedArea.enName,
      name: "enName",
      custom: true,
      customName: { key: "nameCustomize" },
      customValue: savedArea.scNameDisable,
      isEndOfLine: false,
      required: true,
      helperTextIcon: true,
      helperText: AreaValidation.getErrorMessages(areaValidationConstants.KEY_EN_NAME),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "tcName" },
      value: savedArea.tcName,
      name: "tcName",
      translateName: savedArea.scNameDisable ? ["scName"] : null,
      inputList: areaInputList,
      setInputList: setAreaInputList,
      isEndOfLine: false,
      required: true,
      helperTextIcon: true,
      helperText: AreaValidation.getErrorMessages(areaValidationConstants.KEY_TC_NAME),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "scName" },
      value: savedArea.scName,
      name: "scName",
      inputList: areaInputList,
      setInputList: setAreaInputList,
      isEndOfLine: true,
      disabled: savedArea.scNameDisable,
      required: true,
      helperTextIcon: true,
      helperText: AreaValidation.getErrorMessages(areaValidationConstants.KEY_SC_NAME),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "landmarkOrder" },
      value: savedArea.landmarkOrder,
      type: constants.TYPE.NUMBER,
      min: 0,
      name: "landmarkOrder",
      isEndOfLine: false,
      required: true,
      helperTextIcon: true,
      helperText: AreaValidation.getErrorMessages(areaValidationConstants.KEY_LANDMARK_ORDER),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "status" },
      value: savedArea.status,
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.RESTAURANT_AREA.STATUS,
      name: "status",
      isEndOfLine: false,
      disableClearable: true,
      required: true,
      helperTextIcon: true,
      helperText: AreaValidation.getErrorMessages(areaValidationConstants.KEY_STATUS),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
  ]
  const content = [
    {
      tab: tempAreaEditList.map((inputSetting, index) => {
        let content;
        switch (inputSetting.type) {
          case constants.TYPE.SELECT:
            content =
              <TempAutoSelectInput inputSetting={inputSetting} handleChange={onChangeInput} />
            break;
          default:
            content =
              <TempTextInput inputSetting={inputSetting} handleChange={onChangeInput} />
        }
        return <div className="edit-display-wrapper" key={index}>
          {inputSetting.custom && <TempCustomCheckBox className="customize-btn" value={inputSetting.customValue} customName={inputSetting.customName} onSelectCheckbox={onSelectCheckbox} />}
          {content}
          {inputSetting.isEndOfLine && <div></div>}
        </div>
      }),
      btn: true
    },
    {
      tab: <DistrictList
        newPath={constants.PATH.SHOP.RESTAURANT_AREA_DISTRICT_MAP}
        newFilter={{ id: params.id }}
        newListTitles={[
          {
            key: constants.LIST_DISPLAY_TYPE.STRING,
            value: "districtId",
            sort: true
          }, {
            key: constants.LIST_DISPLAY_TYPE.STRING,
            value: "name",
            sort: false
          }, {
            key: constants.LIST_DISPLAY_TYPE.STRING,
            value: "districtStatus",
            sort: true
          }
        ]}
        editBtn={false}
        createBtn={false} />,
      btn: false
    }
  ]
  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: "save" },
      onClick: onClickSave,
      className: "margin-left-16",
      icon: <SaveIcon />
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: "clear" },
      disabled: false,
      onClick: onClickClear,
      className: "margin-left-16",
      icon: <ClearIcon />
    }
  ]

  function onSelectCheckbox(value) {
    dispatch(setAreaValue("scNameDisable", savedArea, "", value));
  }

  const onClickBackToEdit = () => {
    setDialog({
      open: false,
      dialogActions: []
    });
    onClickClear();
  };
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: []
    })
    history.push("/" + constants.PATH.SHOP.RESTAURANT_AREA);
  };

  function onChangeInput(name, e) {
    if (savedArea.scNameDisable === true && name === "tcName") {
      dispatch(setAreaValue("CHANGE_TC_NAME_AND_SC_NAME", savedArea, "", e));
    } else if (name === "landmarkOrder") {
      dispatch(setAreaValue(name, savedArea, "", Number.isInteger(Number(e)) ? Number(e) : 0));
    } else {
      dispatch(setAreaValue(name, savedArea, "", e));
    }
  }

  function onClickSave() {
    AreaValidation.validateEditArea(savedArea);
    if (AreaValidation.isValid()) {
      put(constants.PATH.SHOP.RESTAURANT_AREA + "/" + params.id, savedArea, (payload) => {
        setDialog({
          open: true,
          onClose: onClickBackToEdit,
          dialogContentText: { key: "editSuccess" },
          dialogActions: [
            { label: { key: "backEdit" }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
            { label: { key: "backList" }, onClick: onClickBackToList, icon: <LowPriorityIcon /> }
          ]
        })
        setClear(false)
      }, undefined, store);
      AreaValidation.resetErrorMessages();
    } else {
      setErrorVersion(AreaValidation.getVersion());
    }
  }

  function onClickClear() {
    setClear(true)
  }

  useEffect(() => {
    if (clear === true) {
      getOne(constants.PATH.SHOP.RESTAURANT_AREA + "/" + params.id, undefined, (payload) => {
        payload.scNameDisable = getScDisabled(payload.tcName, payload.scName);
        dispatch(setArea(_.cloneDeep(payload)));
        setAreaInputList(_.cloneDeep(payload))
        setReady(true)
        setClear(false)
      }, undefined, store);
    }
    AreaValidation.resetErrorMessages();
  }, [clear]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready &&
    <>
      <EditCreateDisplay
        code={savedArea && savedArea.areaId ? savedArea.areaId : ""}
        resource={resource}
        tabs={tabs}
        content={content}
        onChangeInput={onChangeInput}
        bottomBtns={bottomBtns}
        display="edit"
      />
      {dialog && dialog.open &&
        <GlobalDialog dialogInfo={dialog} />
      }
    </>
  )
};